module.exports = __webpack_public_path__ + "static/media/step3.e122edd4.png";